(function () {
  'use strict';

  var storageKey = 'ruqy-wishlist';

  function readWishlist() {
    try {
      var saved = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(handles) {
    window.localStorage.setItem(storageKey, JSON.stringify(handles));
    document.dispatchEvent(new CustomEvent('ruqy:wishlist-change', { detail: { handles: handles } }));
  }

  function initWishlistPage(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var grid = root.querySelector('[data-ruqy-wishlist-grid]');
    var empty = root.querySelector('[data-ruqy-wishlist-empty]');
    var status = root.querySelector('[data-ruqy-wishlist-status]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-wishlist-card]'));

    function render() {
      var handles = readWishlist();
      var visibleCount = 0;

      cards.forEach(function (card) {
        var isSaved = handles.includes(card.dataset.productHandle);
        card.hidden = !isSaved;
        if (isSaved) visibleCount += 1;
      });

      grid.hidden = visibleCount === 0;
      empty.hidden = visibleCount !== 0;
    }

    cards.forEach(function (card) {
      var removeButton = card.querySelector('[data-wishlist-remove]');
      if (!removeButton) return;

      removeButton.addEventListener('click', function () {
        var handles = readWishlist().filter(function (handle) {
          return handle !== card.dataset.productHandle;
        });
        writeWishlist(handles);
        if (status) status.textContent = 'Piece removed from your likes.';
        render();
      });
    });

    window.addEventListener('storage', render);
    document.addEventListener('ruqy:wishlist-change', render);
    render();
  }

  function boot() {
    document.querySelectorAll('[data-ruqy-wishlist-page]').forEach(initWishlistPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ruqy-wishlist-page]');
    if (root) initWishlistPage(root);
  });
})();
